module.exports = __webpack_public_path__ + "assets/img/feature_01.3bacd802.png";